<template>
    <div id="fv">
        <div class="banner" ref="banner">
            <div>
                <iframe src="./computer/index.html" id="iframe" ref="iframeComputer"></iframe>

                <Transition>
                    <div class="contact-banner" v-if="endAnimationComputer">
                        <p>{{ $t("message.fv.banner_1") }}</p>
                        <span @click="scrollToContact()">{{ $t("message.fv.banner_2") }}</span>
                    </div>
                </Transition>

                <div class="mask"></div>
                <!--<Transition>
                    <div class="scrolldown" v-if="endAnimationComputer"><div></div></div>
                </Transition>-->
            </div>
        </div>

        <div class="banner-intro">
            <h1 v-html="$t('message.fv.banner')"></h1>
        </div>

        <div class="line-1">
            <div>
                <div>
                    <h2>{{ $t("message.fv.line_1.text_1") }}</h2>

                    <h3>{{ $t("message.fv.line_1.text_8") }}</h3>

                    <div class="tags">
                        <div>
                            {{ $t("message.fv.line_1.text_2") }}
                        </div>
                        <div>
                            {{ $t("message.fv.line_1.text_3") }}
                        </div>
                        <div>
                            {{ $t("message.fv.line_1.text_4") }}
                        </div>
                    </div>

                    <ul>
                        <li>
                            <div>
                                <Check color="#9d7d58" />
                            </div>
                            <div v-html="$t('message.fv.line_1.text_5')"></div>
                        </li>
                        <li>
                            <div>
                                <Check color="#9d7d58" />
                            </div>
                            <div v-html="$t('message.fv.line_1.text_6')"></div>
                        </li>
                        <li>
                            <div>
                                <Check color="#9d7d58" />
                            </div>
                            <div v-html="$t('message.fv.line_1.text_6')"></div>
                        </li>
                    </ul>
                </div>
                <div class="iframe">
                    <iframe src="./mobile/index.html" id="iframe" ref="iframeMobile"></iframe>
                </div>
            </div>
        </div>

        <div class="line-2">
            <div>
                <div>
                    <h2>{{ $t("message.fv.line_2.text_1") }}</h2>

                    <h3>{{ $t("message.fv.line_2.text_2") }}</h3>

                    <ul>
                        <li>
                            <div>
                                <Check color="#fff" />
                            </div>
                            <div v-html="$t('message.fv.line_2.text_3')"></div>
                        </li>
                        <li>
                            <div>
                                <Check color="#fff" />
                            </div>
                            <div v-html="$t('message.fv.line_2.text_4')"></div>
                        </li>
                        <li>
                            <div>
                                <Check color="#fff" />
                            </div>
                            <div v-html="$t('message.fv.line_2.text_5')"></div>
                        </li>
                    </ul>

                    <div v-html="$t('message.fv.line_2.text_6')" class="text-6"></div>
                </div>

                <div class="iframe">
                    <iframe src="./monitor/index.html" id="iframe" ref="iframeMonitor"></iframe>
                </div>

                <div>
                    <div>
                        <img src="@/assets/img/page_fv/page_formaVisa-14.png" alt="" />
                    </div>
                    <div v-html="$t('message.fv.line_2.text_7')"></div>
                </div>
            </div>
        </div>

        <div class="line-3">
            <div>
                <h2>{{ $t("message.fv.line_3.text_1") }}</h2>

                <div class="imgs">
                    <div>
                        <img src="@/assets/img/page_fv/clients_FV.png" alt="" />
                    </div>
                    <div>
                        <img src="@/assets/img/clients_logos.png" alt="" />
                    </div>
                </div>

                <h3>{{ $t("message.fv.line_3.text_2") }}</h3>

                <div>
                    <div>
                        <img src="@/assets/img/page_fv/page_formaVisa-15.png" alt="" />
                    </div>
                    <div v-html="$t('message.fv.line_3.text_3')"></div>
                </div>
            </div>
        </div>

        <div class="line-4">
            <div>
                <h2>{{ $t("message.fv.line_4.text_1") }}</h2>
                <h3>{{ $t("message.fv.line_4.text_2") }}</h3>

                <div class="img">
                    <img src="@/assets/img/page_fv/page_formaVisa-13.png" alt="" />
                </div>

                <div>
                    <div @click="displayModalFunctionality(0)">
                        <div class="img">
                            <img src="@/assets/img/page_fv/page_formaVisa-09.png" alt="" />
                        </div>
                        <div v-html="$t('message.fv.line_4.text_3')" class="content"></div>
                        <img src="@/assets/img/chevron-right.png" alt="" />
                    </div>
                    <div @click="displayModalFunctionality(1)">
                        <div class="img">
                            <img src="@/assets/img/page_fv/page_formaVisa-11.png" alt="" />
                        </div>
                        <div v-html="$t('message.fv.line_4.text_4')" class="content"></div>
                        <img src="@/assets/img/chevron-right.png" alt="" />
                    </div>
                    <div @click="displayModalFunctionality(2)">
                        <div class="img">
                            <img src="@/assets/img/page_fv/page_formaVisa-10.png" alt="" />
                        </div>
                        <div v-html="$t('message.fv.line_4.text_5')" class="content"></div>
                        <img src="@/assets/img/chevron-right.png" alt="" />
                    </div>
                    <div @click="displayModalFunctionality(3)">
                        <div class="img">
                            <img src="@/assets/img/page_fv/page_formaVisa-12.png" alt="" />
                        </div>
                        <div v-html="$t('message.fv.line_4.text_6')" class="content"></div>
                        <img src="@/assets/img/chevron-right.png" alt="" />
                    </div>
                </div>
            </div>
        </div>

        <div class="line-5">
            <div>
                <div>
                    <h2>{{ $t("message.fv.line_5.text_1") }}</h2>
                    <h3 v-html="$t('message.fv.line_5.text_2')"></h3>

                    <ul>
                        <li>
                            <div class="img">
                                <img src="@/assets/img/page_fv/page_formaVisa-06.png" alt="" />
                            </div>
                            <div v-html="$t('message.fv.line_5.text_3')"></div>
                        </li>
                        <li>
                            <div class="img">
                                <img src="@/assets/img/page_fv/page_formaVisa-07.png" alt="" />
                            </div>
                            <div v-html="$t('message.fv.line_5.text_4')"></div>
                        </li>
                        <li>
                            <div class="img">
                                <img src="@/assets/img/page_fv/page_formaVisa-08.png" alt="" />
                            </div>
                            <div v-html="$t('message.fv.line_5.text_5')"></div>
                        </li>
                    </ul>
                </div>
                <div class="bg-img"></div>
                <!--<div>
                    <div>
                        <img src="@/assets/img/page_fv/page_formaVisa-02.png" alt="" />
                    </div>
                </div>-->
            </div>
        </div>

        <div class="line-6">
            <div>
                <h2>{{ $t("message.fv.line_6.text_1") }}</h2>

                <div>
                    <div @click="displayModalExtra(0)">
                        <div>
                            <div class="title">
                                <span>{{ $t("message.fv.line_6.title_1") }}</span>
                            </div>
                            <div class="desc">
                                <span v-html="$t('message.fv.line_6.content_1')"></span>
                            </div>
                            <div class="media">
                                <img src="@/assets/img/page_fv/page_formaVisa-03.png" alt="" />
                            </div>
                            <span class="btn">
                                {{ $t("message.fv.line_6.btn_1") }}
                            </span>
                        </div>
                    </div>

                    <div @click="displayModalExtra(1)">
                        <div>
                            <div class="title">
                                <span>{{ $t("message.fv.line_6.title_2") }}</span>
                            </div>
                            <div class="desc">
                                <span v-html="$t('message.fv.line_6.content_2')"></span>
                            </div>
                            <div class="media">
                                <img src="@/assets/img/page_fv/page_formaVisa-04.png" alt="" />
                            </div>
                            <span class="btn">
                                {{ $t("message.fv.line_6.btn_2") }}
                            </span>
                        </div>
                    </div>

                    <div @click="displayModalExtra(2)">
                        <div>
                            <div class="title">
                                <span>{{ $t("message.fv.line_6.title_3") }}</span>
                            </div>
                            <div class="desc">
                                <span v-html="$t('message.fv.line_6.content_3')"></span>
                            </div>
                            <div class="media">
                                <img src="@/assets/img/page_fv/page_formaVisa-05.png" alt="" />
                            </div>
                            <span class="btn">
                                {{ $t("message.fv.line_6.btn_3") }}
                            </span>
                        </div>
                    </div>
                </div>

                <h3>{{ $t("message.fv.line_6.text_2") }}</h3>
            </div>
        </div>
    </div>

    <Contact />
</template>

<script>
import Contact from "../components/Contact.vue";
import Check from "../components/img/Check.vue";

export default {
    name: "Harkhan",
    data() {
        return {
            local: "fr",
            isMobile: false,
            iframeMobileStatus: false,
            iframeMonitorStatus: false,
            animationMobile: false,
            animationMonitor: false,
            endAnimationComputer: false,
        };
    },
    components: {
        Contact,
        Check,
    },
    watch: {
        "$i18n.locale": function (locale) {
            this.local = locale;
        },
    },
    beforeCreate() {},
    mounted() {
        let _this = this;
        this.local = this.$i18n.locale;

        const iframeComputer = this.$refs.iframeComputer;
        const iframeMobile = this.$refs.iframeMobile;
        const iframeMonitor = this.$refs.iframeMonitor;

        // Chargement du module computer
        window.addEventListener("message", function (event) {
            if (event.data && event.data === "moduleLoadedComputer") _this.playAnimationComputer();
        });
        // Chargement du module mobile
        window.addEventListener("message", function (event) {
            if (event.data && event.data === "moduleLoadedMobile") _this.iframeMobileStatus = true;
        });
        // Chargement du module monitor
        window.addEventListener("message", function (event) {
            if (event.data && event.data === "moduleLoadedMonitor") _this.iframeMonitorStatus = true;
        });

        // Fin de l'animation computer
        window.addEventListener("message", function (event) {
            if (event.data && event.data === "endAnimationComputer") _this.endAnimationComputer = true;
        });

        /**
         * Scroll
         */
        window.addEventListener("scroll", function () {
            if (iframeMobile && iframeMonitor && _this.iframeMobileStatus && _this.iframeMonitorStatus) {
                let rectIframeMobile = iframeMobile.getBoundingClientRect();
                let rectIframeMonitor = iframeMonitor.getBoundingClientRect();

                // Iframe mobile
                if (rectIframeMobile.bottom < window.innerHeight && rectIframeMobile.top > 0 && !_this.animationMobile) {
                    _this.animationMobile = true;
                    _this.playAnimationMobile();
                }
                if ((rectIframeMobile.bottom < 0 && rectIframeMobile.top < 0) || (rectIframeMobile.bottom > window.innerHeight && rectIframeMobile.top > window.innerHeight)) _this.animationMobile = false;

                // Iframe monitor
                if (rectIframeMonitor.bottom < window.innerHeight && rectIframeMonitor.top > 0 && !_this.animationMonitor) {
                    _this.animationMonitor = true;
                    _this.playAnimationMonitor();
                }
                if ((rectIframeMonitor.bottom < 0 && rectIframeMonitor.top < 0) || (rectIframeMonitor.bottom > window.innerHeight && rectIframeMonitor.top > window.innerHeight)) _this.animationMonitor = false;
            }
        });
    },
    created() {
        let _this = this;
        window.addEventListener("resize", function (e) {
            _this.isItMobile();
        });
        this.isItMobile();
    },
    methods: {
        playAnimationComputer() {
            const iframeComputer = this.$refs.iframeComputer;
            let data = {};
            data.computerLaunch = true;
            iframeComputer.contentWindow.postMessage(JSON.stringify(data), "*");
        },
        playAnimationMobile() {
            const iframeMobile = this.$refs.iframeMobile;
            let data = {};
            data.mobileLaunch = true;
            iframeMobile.contentWindow.postMessage(JSON.stringify(data), "*");
        },
        playAnimationMonitor() {
            const iframeMonitor = this.$refs.iframeMonitor;
            let data = {};
            data.monitorLaunch = true;
            iframeMonitor.contentWindow.postMessage(JSON.stringify(data), "*");
        },
        isItMobile() {
            let windowWidth = window.innerWidth;
            this.isMobile = windowWidth < 992 ? true : false;
        },
        displayModalFunctionality(index) {
            this.$store.dispatch("app/displayModal", {
                display: true,
                name: "harkhan_modal",
                type: "functionality",
                index: index,
                content: this.$store.state.app.page_fv.functionality[this.local][index],
            });
        },
        displayModalExtra(index) {
            this.$store.dispatch("app/displayModal", {
                display: true,
                name: "harkhan_modal",
                type: "extra",
                index: index,
                content: this.$store.state.app.page_fv.extra[this.local][index],
            });
        },
        scrollToContact() {
            document.querySelector("#contact").scrollIntoView({
                behavior: "smooth",
            });
        },
    },
};
</script>

<style lang="scss" scoped>
$bg_banner_1: #56a7db;
$bg_banner_2: #ffeaca;
$bg_banner_3: #0c143a;

// Transition pavé texte header
.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
////////
///
#fv {
    position: relative;

    h1,
    h2,
    li,
    ul {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    .banner {
        position: relative;
        //height: 500vh;

        > div {
            width: 100%;
            //position: sticky;
            //top: 0;
            padding-top: 56.25%; /* 16:9 Aspect Ratio */
        }

        iframe {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            border: 0;
            box-shadow: 0 0 0;
            box-sizing: border-box;
        }

        .contact-banner {
            text-align: center;
            position: absolute;
            top: 45%;
            right: 15%;
            background-color: #0c143a;
            border-radius: 10px;
            padding: 1rem;
            box-sizing: border-box;
            color: #fff;
            font-family: Oswald, sans-serif;
            text-transform: uppercase;
            z-index: 1;
            font-size: 2.4rem;

            p {
                margin: 0 0 0.5rem;
            }

            span {
                background-color: #56a7db;
                border-radius: 10px;
                box-sizing: border-box;
                padding: 0.5rem 1rem;
                font-size: 1.2rem;
                display: block;
                cursor: pointer;
            }
        }

        .mask {
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
        }
    }

    .banner-intro {
        background-color: $bg_banner_1;

        h1 {
            font-family: Oswald, sans-serif;
            text-align: center;
            color: #fff;
            font-size: 2.4rem;
            font-weight: 400;
            max-width: 1400px;
            margin: auto;
            width: 100%;
            padding: 1.5rem 2rem;
            box-sizing: border-box;
        }
    }

    .line-1 {
        background-color: $bg_banner_2;

        > div {
            display: flex;
            align-items: center;
            max-width: 1400px;
            margin: auto;
            width: 100%;
            padding: 1.5rem 2rem;
            box-sizing: border-box;
            justify-content: space-between;

            > div {
                &:first-child {
                    flex: 0 0 55%;
                    font-family: Oswald, sans-serif;

                    h2 {
                        color: #9d7d58;
                        font-size: 2rem;
                        font-weight: 500;
                        text-transform: uppercase;
                        margin: 0;
                    }

                    h3 {
                        color: #0c143a;
                        font-size: 1.8rem;
                        font-weight: 500;
                        text-transform: uppercase;
                        margin: 0 0 1rem;
                    }

                    .tags {
                        display: flex;
                        align-items: center;

                        > div {
                            font-size: 1.2rem;
                            background-color: #0c143a;
                            color: #fff;
                            margin-right: 1rem;
                            border-radius: 10px;
                            padding: 0.2rem 1rem;
                        }
                    }

                    ul {
                        margin-top: 1rem;

                        li {
                            display: flex;
                            flex-flow: row nowrap;
                            align-items: center;

                            > div {
                                font-size: 1.2rem;
                                color: #0c143a;
                                font-weight: 400;

                                &:first-child {
                                    width: 50px;
                                    margin-right: 0.5rem;
                                    flex: 0 0 50px;

                                    svg {
                                        width: 100%;
                                        height: auto;
                                    }
                                }
                            }
                        }
                    }
                }

                &:last-child {
                    flex: 0 0 45%;
                }
            }

            .iframe {
                width: 100%;
                aspect-ratio: 4/3;
                overflow: hidden;
                position: relative;

                iframe {
                    width: 100%;
                    height: 100%;
                    border: 0;
                    box-shadow: 0 0 0;
                    box-sizing: border-box;
                    vertical-align: middle;
                }
            }
        }
    }

    .line-2 {
        background-color: $bg_banner_1;

        > div {
            display: flex;
            flex-flow: row wrap;
            align-items: center;
            max-width: 1400px;
            margin: auto;
            width: 100%;
            padding: 1.5rem 2rem;
            justify-content: space-between;
            box-sizing: border-box;

            > div {
                &:first-child {
                    font-family: Oswald, sans-serif;
                    flex: 0 0 55%;

                    h2 {
                        color: #fff;
                        font-size: 2rem;
                        font-weight: 500;
                        text-transform: uppercase;
                        margin: 0;
                    }

                    h3 {
                        color: #0c143a;
                        font-size: 1.8rem;
                        font-weight: 500;
                        text-transform: uppercase;
                        margin: 0 0 1rem;
                    }

                    ul {
                        margin-top: 1rem;

                        li {
                            display: flex;
                            flex-flow: row nowrap;
                            align-items: center;

                            > div {
                                font-size: 1.2rem;
                                color: #0c143a;
                                font-weight: 400;

                                &:first-child {
                                    width: 50px;
                                    flex: 0 0 50px;
                                    margin-right: 0.5rem;

                                    svg {
                                        width: 100%;
                                        height: auto;
                                    }
                                }
                            }
                        }
                    }

                    .text-6 {
                        color: #0c143a;
                        font-size: 1.8rem;
                        font-weight: 500;
                        text-transform: uppercase;
                        margin: 2rem 0 1rem;
                    }
                }

                &:nth-child(2) {
                    flex: 0 0 45%;

                    img {
                        max-width: 100%;
                    }
                }

                &:last-child {
                    flex: 100%;
                    display: flex;
                    align-items: center;
                    font-weight: 500;
                    font-family: "Roboto", sans-serif;
                    font-size: 1.2rem;

                    img {
                        max-width: 70px;
                        margin-right: 1rem;
                    }
                }
            }

            .iframe {
                width: 100%;
                aspect-ratio: 4/3;
                overflow: hidden;
                position: relative;

                iframe {
                    width: 100%;
                    height: 100%;
                    border: 0;
                    box-shadow: 0 0 0;
                    box-sizing: border-box;
                }
            }
        }
    }

    .line-3 {
        background-color: $bg_banner_3;

        > div {
            display: flex;
            flex-flow: column;
            align-items: center;
            max-width: 1400px;
            margin: auto;
            width: 100%;
            padding: 1.5rem 2rem;
            font-family: Oswald, sans-serif;
            justify-content: space-between;
            box-sizing: border-box;

            h2 {
                color: #e1c89e;
                font-size: 2rem;
                font-weight: 500;
                text-transform: uppercase;
                margin: 0 0 2rem;
            }

            h3 {
                color: #e1c89e;
                font-size: 1.8rem;
                font-weight: 500;
                text-transform: uppercase;
                margin: 2rem 0 1rem;
                text-align: left;
                width: 100%;
            }

            .imgs {
                display: flex;
                flex-flow: row nowrap;
                justify-content: space-between;
                align-items: stretch;
                width: 100%;

                > div {
                    flex: 0 0 49%;
                    border-radius: 15px;
                    overflow: hidden;
                    background-color: #fff;

                    img {
                        width: 100%;
                        display: block;
                    }
                }
            }

            > div:not(.imgs) {
                width: 100%;
                color: #fff;
                display: flex;
                align-items: center;
                font-size: 1.2rem;
                font-family: "Roboto", sans-serif;
                font-weight: 500;

                img {
                    max-width: 70px;
                    margin-right: 1rem;
                }
            }
        }
    }

    .line-4 {
        background-color: $bg_banner_1;

        > div {
            display: flex;
            flex-flow: column;
            align-items: center;
            max-width: 1400px;
            margin: auto;
            width: 100%;
            padding: 1.5rem 2rem;
            font-family: Oswald, sans-serif;
            box-sizing: border-box;

            h2 {
                color: #fff;
                font-size: 2rem;
                font-weight: 500;
                text-transform: uppercase;
                text-align: left;
                width: 100%;
            }

            h3 {
                color: #0c143a;
                font-size: 1.8rem;
                font-weight: 500;
                text-transform: uppercase;
                margin: 2rem 0;
                text-align: left;
                width: 100%;
            }

            > .img {
                width: 100%;
                grid-template-columns: repeat(1, 1fr);
                background-color: #fff;
                border-radius: 15px;
                margin-bottom: 1rem;
                overflow: hidden;

                > img {
                    width: 100%;
                }
            }

            > div {
                justify-content: space-between;
                width: 100%;
                grid-auto-rows: 1fr;
                grid-template-columns: repeat(2, 1fr);
                display: grid;
                gap: 1rem;

                > div {
                    border-radius: 15px;
                    overflow: hidden;
                    background-color: #0c143a;
                    padding: 1rem;
                    box-sizing: border-box;
                    display: flex;
                    flex-flow: row nowrap;
                    align-items: center;
                    justify-content: space-around;
                    width: 100%;
                    cursor: pointer;

                    .img {
                        img {
                            max-width: 120px;
                        }
                    }

                    .content {
                        flex: 1;
                        text-align: left;
                        color: #fff;
                        font-size: 1.4rem;
                        padding-left: 2rem;
                        box-sizing: border-box;
                    }
                }
            }
        }
    }

    .line-5 {
        background-color: $bg_banner_2;

        > div {
            display: flex;
            align-items: stretch;
            max-width: 1400px;
            margin: auto;
            width: 100%;
            padding: 1.5rem 2rem;
            justify-content: space-between;
            box-sizing: border-box;

            > div {
                &:first-child {
                    flex: 0 0 55%;
                    font-family: Oswald, sans-serif;

                    h2 {
                        color: #9d7d58;
                        font-size: 2rem;
                        font-weight: 500;
                        text-transform: uppercase;
                        margin: 0;
                    }

                    h3 {
                        color: #0c143a;
                        font-size: 1.8rem;
                        font-weight: 500;
                        text-transform: uppercase;
                        margin: 0 0 1rem;
                    }

                    ul {
                        margin-top: 1rem;

                        li {
                            display: flex;
                            flex-flow: row nowrap;
                            align-items: center;
                            margin-bottom: 1rem;
                            padding-right: 1rem;
                            box-sizing: border-box;

                            > div {
                                font-size: 1.2rem;
                                color: #0c143a;
                                font-weight: 300;
                                font-family: "Roboto", sans-serif;

                                &:first-child {
                                    margin-right: 1rem;

                                    img {
                                        max-width: 120px;
                                    }
                                }
                            }
                        }
                    }
                }

                &:last-child {
                    background: url("@/assets/img/page_fv/page_formaVisa-02.png");
                    flex: 0 0 40%;
                    display: flex;
                    justify-content: flex-end;
                    background-repeat: no-repeat;
                    background-size: contain;
                    background-position: right;
                }
            }
        }
    }

    .line-6 {
        background-color: $bg_banner_3;

        h2 {
            color: #fff;
            font-size: 2rem;
            font-weight: 500;
            text-transform: uppercase;
            margin: 0 0 1rem;
            font-family: Oswald, sans-serif;
        }

        h3 {
            color: #fff;
            font-size: 2rem;
            font-weight: 500;
            text-transform: uppercase;
            margin: 3rem 0 0;
            font-family: Oswald, sans-serif;
        }

        > div {
            max-width: 1400px;
            margin: auto;
            width: 100%;
            padding: 1.5rem 2rem;
            box-sizing: border-box;

            > div {
                font-family: "Oswald", sans-serif;
                display: flex;
                flex-flow: row wrap;
                align-items: stretch;
                justify-content: space-between;
                max-width: 1400px;
                width: 100%;
                margin: auto;

                > div,
                > a {
                    color: #00003a;
                    text-decoration: none;
                    padding: 1rem;
                    box-sizing: border-box;
                    overflow: hidden;
                    border-radius: 15px;
                    background: #fff;
                    box-shadow: 0px 0px 34px 10px rgba(0, 0, 0, 0.3);
                    transition: all 0.3s;
                    flex: 0 0 31%;
                    cursor: pointer;
                    transition: all 0.3s;
                    margin-bottom: 3rem;

                    &:hover,
                    &:focus {
                        transform: scale(1.05);
                        z-index: 1;
                    }

                    > div {
                        display: flex;
                        flex-flow: column;
                        height: 100%;
                    }
                }

                .title {
                    text-transform: uppercase;
                    font-weight: 900;
                    font-size: 1.3rem;
                    display: flex;
                    align-items: center;
                    padding: 0 0 1rem;
                    box-sizing: border-box;
                    font-family: Oswald, sans-serif;
                }

                .desc {
                    font-family: "Roboto", sans-serif;
                    font-weight: 300;
                    font-size: 1.2rem;
                    display: flex;
                    align-items: flex-start;
                    padding: 0;
                    box-sizing: border-box;
                    height: 84px;
                    flex: 1;
                    color: #000;
                }

                .media {
                    width: 100%;
                    aspect-ratio: 16/9;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 1rem 0;

                    img {
                        width: 100%;
                        border-radius: 15px;
                    }
                }

                .btn {
                    background-color: #00003a;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0.6rem 1rem;
                    font-size: 1.4rem;
                    border-radius: 15px;
                    text-transform: uppercase;
                }
            }
        }
    }
}

/* Scroll icon */
.scrolldown {
    position: absolute;
    top: 0;
    bottom: 2rem;
    height: calc(100% - 2rem);
    left: calc(50vw - 15px);
    display: flex;
    flex-flow: row nowrap;
    align-items: center;

    > div {
        position: absolute;
        width: 30px;
        height: 50px;
        border: 3px solid #ff0000;
        border-radius: 25px;
        position: sticky;
        top: calc(100vh - 50px - 2rem);
        transition: all 0.5s;

        &::before {
            content: "";
            position: absolute;
            bottom: 30px;
            left: 50%;
            transform: translateX(-50%);
            width: 6px;
            height: 6px;
            background-color: #ff0000;
            border-radius: 100%;
            box-shadow: 0px -5px 3px 1px rgba(255, 0, 0, 0.6);
            animation: scrolldown-anim 2s infinite;
        }

        &::after {
            content: "";
            position: absolute;
            bottom: -12px;
            left: 50%;
            transform: translateX(-50%) rotate(45deg);
            width: 7px;
            height: 7px;
            border: 2px solid #ff0000;
            border-top: none;
            border-left: none;
            animation: pulse 2s infinite;
        }
    }
}

@keyframes scrolldown-anim {
    0% {
        opacity: 0;
        height: 6px;
    }
    40% {
        opacity: 1;
        height: 10px;
    }
    80% {
        opacity: 0;
        transform: translate(-50%, 20px);
        height: 10px;
    }
    100% {
        opacity: 0;
        height: 3px;
    }
}

@media (max-width: 1400px) {
    #fv {
        .banner {
            .contact-banner {
                top: 45%;
                right: 5%;
            }
        }
    }
}

@media (max-width: 1200px) {
    #fv {
        .banner {
            .contact-banner {
                padding: 1rem;
                font-size: 2rem;

                p {
                    margin: 0 0 0.5rem;
                }

                span {
                    padding: 0.5rem 1rem;
                    font-size: 1.2rem;
                }
            }
        }

        .banner-intro {
            h1 {
                font-size: 1.8rem;
                padding: 1.5rem 2rem;
            }
        }

        .line-1 {
            background-color: $bg_banner_2;

            > div {
                padding: 1.5rem 2rem;

                > div {
                    &:first-child {
                        flex: 0 0 55%;

                        h2 {
                            font-size: 1.6rem;
                        }

                        h3 {
                            font-size: 1.4rem;
                            margin: 0 0 1rem;
                        }

                        .tags {
                            > div {
                                font-size: 1rem;
                                margin-right: 0.5rem;
                                padding: 0.2rem 1rem;
                            }
                        }

                        ul {
                            margin-top: 1rem;

                            li {
                                display: flex;
                                flex-flow: row nowrap;
                                align-items: center;

                                > div {
                                    font-size: 1rem;

                                    &:first-child {
                                        width: 40px;
                                        flex: 0 0 40px;
                                        margin-right: 0.5rem;
                                    }
                                }
                            }
                        }
                    }

                    &:last-child {
                        flex: 0 0 40%;
                    }
                }
            }
        }

        .line-2 {
            background-color: $bg_banner_1;

            > div {
                padding: 1.5rem 2rem;

                > div {
                    &:first-child {
                        flex: 0 0 55%;

                        h2 {
                            font-size: 1.6rem;
                        }

                        h3 {
                            font-size: 1.4rem;
                            margin: 0 0 1rem;
                        }

                        ul {
                            margin-top: 1rem;

                            li {
                                display: flex;
                                flex-flow: row nowrap;
                                align-items: center;

                                > div {
                                    font-size: 1rem;

                                    &:first-child {
                                        width: 40px;
                                        flex: 0 0 40px;
                                        margin-right: 0.5rem;
                                    }
                                }
                            }
                        }

                        .text-6 {
                            font-size: 1.4rem;
                            margin: 2rem 0 1rem;
                        }
                    }

                    &:nth-child(2) {
                        flex: 0 0 40%;
                    }
                }
            }
        }

        .line-3 {
            > div {
                padding: 1.5rem 2rem;

                h2 {
                    font-size: 1.6rem;
                    margin: 0 0 1.5rem;
                }

                h3 {
                    font-size: 1.4rem;
                    margin: 1.5rem 0 1rem;
                }

                .imgs {
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: space-between;
                    align-items: stretch;
                }
            }
        }

        .line-4 {
            > div {
                padding: 1.5rem 2rem;

                h2 {
                    font-size: 1.6rem;
                }

                h3 {
                    font-size: 1.4rem;
                    margin: 1.5rem 0;
                }

                > .img {
                    aspect-ratio: 3/1;
                    margin-bottom: 1rem;
                }

                > div {
                    justify-content: space-between;
                    width: 100%;
                    grid-auto-rows: 1fr;
                    grid-template-columns: repeat(2, 1fr);
                    display: grid;
                    gap: 1rem;

                    > div {
                        padding: 1rem;

                        .img {
                            img {
                                max-width: 110px;
                            }
                        }

                        .content {
                            font-size: 1.2rem;
                            padding-left: 1rem;
                        }
                    }
                }
            }
        }

        .line-5 {
            > div {
                padding: 1.5rem 2rem;

                > div {
                    &:first-child {
                        flex: 0 0 55%;

                        h2 {
                            font-size: 1.6rem;
                        }

                        h3 {
                            font-size: 1.4rem;
                            margin: 0 0 1rem;
                        }

                        ul {
                            margin-top: 1rem;

                            li {
                                margin-bottom: 1rem;

                                > div {
                                    font-size: 1rem;
                                    color: #0c143a;
                                    font-weight: 400;

                                    &:first-child {
                                        margin-right: 1rem;

                                        img {
                                            max-width: 110px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .line-6 {
            h2 {
                font-size: 1.6rem;
                margin: 0 0 1rem;
            }

            h3 {
                font-size: 1.6rem;
                margin: 1rem 0 0;
            }

            > div {
                padding: 1.5rem 2rem;

                > div {
                    .title {
                        font-size: 1.2rem;
                        padding: 0 0 1rem;
                    }

                    .desc {
                        font-size: 1.2rem;
                    }

                    .media {
                        margin: 1rem 0;
                    }

                    .btn {
                        padding: 0.6rem 1rem;
                        font-size: 1.2rem;
                    }
                }
            }
        }
    }
}

@media (max-width: 992px) {
    /* Scroll icon */
    .scrolldown {
        > div {
            width: 20px;
            height: 40px;
            border: 2px solid #ff0000;
        }
    }

    #fv {
        .banner {
            .contact-banner {
                padding: 1rem;
                font-size: 2rem;

                p {
                    margin: 0 0 0.5rem;
                }

                span {
                    padding: 0.5rem 1rem;
                    font-size: 1.2rem;
                }
            }
        }

        .banner-intro {
            h1 {
                font-size: 1.8rem;
                padding: 1.5rem 2rem;
            }
        }

        .line-1 {
            background-color: $bg_banner_2;

            > div {
                padding: 1.5rem 2rem;

                > div {
                    &:first-child {
                        flex: 0 0 55%;

                        h2 {
                            font-size: 1.6rem;
                        }

                        h3 {
                            font-size: 1.4rem;
                            margin: 0 0 1rem;
                        }

                        .tags {
                            > div {
                                font-size: 1rem;
                                margin-right: 0.5rem;
                                padding: 0.2rem 1rem;
                            }
                        }

                        ul {
                            margin-top: 1rem;

                            li {
                                display: flex;
                                flex-flow: row nowrap;
                                align-items: center;

                                > div {
                                    font-size: 1rem;

                                    &:first-child {
                                        width: 40px;
                                        flex: 0 0 40px;
                                        margin-right: 0.5rem;
                                    }
                                }
                            }
                        }
                    }

                    &:last-child {
                        flex: 0 0 40%;
                    }
                }
            }
        }

        .line-2 {
            background-color: $bg_banner_1;

            > div {
                padding: 1.5rem 2rem;

                > div {
                    &:first-child {
                        flex: 0 0 55%;

                        h2 {
                            font-size: 1.6rem;
                        }

                        h3 {
                            font-size: 1.4rem;
                            margin: 0 0 1rem;
                        }

                        ul {
                            margin-top: 1rem;

                            li {
                                display: flex;
                                flex-flow: row nowrap;
                                align-items: center;

                                > div {
                                    font-size: 1rem;

                                    &:first-child {
                                        width: 40px;
                                        flex: 0 0 40px;
                                        margin-right: 0.5rem;
                                    }
                                }
                            }
                        }

                        .text-6 {
                            font-size: 1.4rem;
                            margin: 2rem 0 1rem;
                        }
                    }

                    &:nth-child(2) {
                        flex: 0 0 40%;
                    }

                    &:last-child {
                        font-size: 1rem;
                    }
                }
            }
        }

        .line-3 {
            > div {
                padding: 1.5rem 2rem;

                h2 {
                    font-size: 1.6rem;
                    margin: 0 0 1.5rem;
                }

                h3 {
                    font-size: 1.4rem;
                    margin: 1.5rem 0 1rem;
                }

                .imgs {
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: space-between;
                    align-items: stretch;
                }

                > div:not(.imgs) {
                    font-size: 1rem;
                }
            }
        }

        .line-4 {
            > div {
                padding: 1.5rem 2rem;

                h2 {
                    font-size: 1.6rem;
                }

                h3 {
                    font-size: 1.4rem;
                    margin: 1.5rem 0;
                }

                > .img {
                    aspect-ratio: 3/1;
                    margin-bottom: 1rem;
                }

                > div {
                    justify-content: space-between;
                    width: 100%;
                    grid-auto-rows: 1fr;
                    grid-template-columns: repeat(2, 1fr);
                    display: grid;
                    gap: 1rem;

                    > div {
                        padding: 1rem;

                        .img {
                            img {
                                max-width: 100px;
                            }
                        }

                        .content {
                            font-size: 1.2rem;
                            padding-left: 1rem;
                        }
                    }
                }
            }
        }

        .line-5 {
            > div {
                padding: 1.5rem 2rem;

                > div {
                    &:first-child {
                        flex: 0 0 55%;

                        h2 {
                            font-size: 1.6rem;
                        }

                        h3 {
                            font-size: 1.4rem;
                            margin: 0 0 1rem;
                        }

                        ul {
                            margin-top: 1rem;

                            li {
                                margin-bottom: 1rem;

                                > div {
                                    font-size: 1rem;
                                    color: #0c143a;
                                    font-weight: 400;

                                    &:first-child {
                                        margin-right: 1rem;

                                        img {
                                            max-width: 100px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .line-6 {
            h2 {
                font-size: 1.6rem;
                margin: 0 0 1rem;
            }

            h3 {
                font-size: 1.6rem;
                margin: 1rem 0 0;
            }

            > div {
                padding: 1.5rem 2rem;

                > div {
                    > div,
                    > a {
                        padding: 1rem;
                        flex: 0 0 100%;
                        max-width: 500px;
                        margin: auto;
                        margin-bottom: 1rem;
                    }

                    .title {
                        font-size: 1.2rem;
                        padding: 0 0 1rem;
                    }

                    .desc {
                        font-size: 1.2rem;
                    }

                    .media {
                        margin: 1rem 0;
                    }

                    .btn {
                        padding: 0.6rem 1rem;
                        font-size: 1.2rem;
                    }
                }
            }
        }
    }
}

@media (max-width: 768px) {
    #fv {
        padding-top: 50px;

        .banner {
            .contact-banner {
                padding: 1rem;
                font-size: 1.6rem;

                p {
                    margin: 0 0 0.5rem;
                }

                span {
                    padding: 0.5rem 1rem;
                    font-size: 1rem;
                }
            }
        }

        .banner-intro {
            h1 {
                font-size: 1.2rem;
                padding: 1rem;
            }
        }

        .line-1 {
            background-color: $bg_banner_2;

            > div {
                padding: 1rem;
                flex-flow: column;
                align-items: flex-start;
                justify-content: center;

                > div {
                    &:first-child {
                        margin-bottom: 1rem;
                        flex: 0 0 100%;
                        width: 100%;

                        h2 {
                            font-size: 1.4rem;
                            text-align: center;
                            width: 100%;
                        }

                        h3 {
                            font-size: 1.2rem;
                            margin: 0 0 1rem;
                            text-align: center;
                            width: 100%;
                        }

                        .tags {
                            > div {
                                font-size: 1rem;
                                margin-right: 0.3rem;
                                padding: 0.2rem 0.5rem;
                            }
                        }

                        ul {
                            margin-top: 1rem;

                            li {
                                display: flex;
                                flex-flow: row nowrap;
                                align-items: center;

                                > div {
                                    font-size: 1rem;

                                    &:first-child {
                                        width: 40px;
                                        flex: 0 0 40px;
                                        margin-right: 0.5rem;
                                    }
                                }
                            }
                        }
                    }

                    &:last-child {
                        flex: 0 0 100%;
                        margin: auto;
                    }
                }

                .iframe {
                    width: 100%;
                    max-width: 400px;

                    img {
                        max-width: 100%;
                    }
                }
            }
        }

        .line-2 {
            > div {
                padding: 1rem;
                flex-flow: column;
                align-items: flex-start;
                justify-content: center;

                > div {
                    &:first-child {
                        flex: 0 0 100%;
                        width: 100%;

                        h2 {
                            font-size: 1.4rem;
                            text-align: center;
                            width: 100%;
                        }

                        h3 {
                            font-size: 1.2rem;
                            margin: 0 0 1rem;
                            width: 100%;
                            text-align: center;
                        }

                        ul {
                            margin-top: 1rem;

                            li {
                                display: flex;
                                flex-flow: row nowrap;
                                align-items: center;

                                > div {
                                    font-size: 1rem;

                                    &:first-child {
                                        width: 40px;
                                        flex: 0 0 40px;
                                        margin-right: 0.5rem;
                                    }
                                }
                            }
                        }

                        .text-6 {
                            font-size: 1.4rem;
                            margin: 2rem 0 1rem;
                        }
                    }

                    &:nth-child(2) {
                        flex: 0 0 100%;
                        margin: auto;
                    }
                }

                .iframe {
                    width: 100%;
                    max-width: 400px;

                    img {
                        max-width: 100%;
                    }
                }
            }
        }

        .line-3 {
            > div {
                padding: 1rem;

                h2 {
                    font-size: 1.4rem;
                    margin: 0 0 1.5rem;
                }

                h3 {
                    font-size: 1.2rem;
                    margin: 1.5rem 0 0;
                }

                .imgs {
                    flex-flow: column;

                    > div {
                        flex: 0 0 100%;
                        width: 100%;
                        min-height: 250px;

                        &:first-child {
                            margin-bottom: 1rem;
                        }
                    }
                }
            }
        }

        .line-4 {
            > div {
                padding: 1rem;

                h2 {
                    font-size: 1.4rem;
                }

                h3 {
                    font-size: 1.2rem;
                    margin: 1rem 0;
                }

                > .img {
                    aspect-ratio: 3/1;
                    margin-bottom: 1rem;
                }

                > div {
                    grid-template-columns: repeat(1, 1fr);

                    > div {
                        .img {
                            img {
                                max-width: 90px;
                            }
                        }

                        .content {
                            font-size: 1.1rem;
                            padding-left: 1rem;
                        }
                    }
                }
            }
        }

        .line-5 {
            > div {
                padding: 1rem;
                flex-flow: column;

                > div {
                    &:first-child {
                        flex: 0 0 100%;

                        h2 {
                            font-size: 1.4rem;
                        }

                        h3 {
                            font-size: 1.2rem;
                            margin: 1rem 0 1rem;
                        }

                        ul {
                            margin-top: 1rem;

                            li {
                                margin-bottom: 1rem;

                                > div {
                                    font-size: 1rem;
                                    color: #0c143a;
                                    font-weight: 400;

                                    &:first-child {
                                        flex: 0 0 80px;
                                        width: 80px;
                                        margin-right: 1rem;

                                        img {
                                            max-width: 90px;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    &:last-child {
                        flex: none;
                        margin-top: 1rem;
                        height: 500px;
                        background-position: center;
                    }
                }
            }
        }

        .line-6 {
            h2 {
                font-size: 1.4rem;
                margin: 0 0 1rem;
            }

            h3 {
                font-size: 1.4rem;
                margin: 1rem 0 0;
            }

            > div {
                padding: 1rem;

                > div {
                    > div,
                    > a {
                        padding: 1rem;
                        flex: 0 0 100%;
                        max-width: 500px;
                        margin: auto;
                        margin-bottom: 1rem;
                    }

                    .title {
                        font-size: 1.2rem;
                        padding: 0 0 1rem;
                    }

                    .desc {
                        font-size: 1.2rem;
                    }

                    .media {
                        margin: 1rem 0;
                    }

                    .btn {
                        padding: 0.6rem 1rem;
                        font-size: 1.2rem;
                    }
                }
            }
        }
    }
}

@media (max-width: 576px) {
    .scrolldown {
        display: none;
    }

    #fv {
        .banner {
            .contact-banner {
                padding: 0.7rem;
                font-size: 1.6rem;
                top: 28%;
                right: 5%;

                p {
                    margin: 0 0 0.5rem;
                }

                span {
                    padding: 0.5rem;
                    font-size: 1rem;
                }
            }
        }
    }
}
</style>
